import createPage from '../create-page'
import LightboxCollectionPage from '../lightbox-collection-page/lightbox-collection-page'

export default createPage(LightboxCollectionPage, 'LIGHTBOX_SUBCOLLECTION', true)



// WEBPACK FOOTER //
// ./src/components/lightbox-sub-collection-page/index.js